import { render, staticRenderFns } from "./HistoryCin.vue?vue&type=template&id=020698bb&scoped=true&"
import script from "./HistoryCin.vue?vue&type=script&lang=js&"
export * from "./HistoryCin.vue?vue&type=script&lang=js&"
import style0 from "./HistoryCin.vue?vue&type=style&index=0&id=020698bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020698bb",
  null
  
)

export default component.exports